import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".pk-view-container ol{margin:8px 0;padding-left:24px}.pk-view-container ol li[data-list-item-diff-id]{min-height:24px;font-size:14px;list-style:inherit}.pk-view-container ol>h1,.pk-view-container ol>h2,.pk-view-container ol>h3,.pk-view-container ol>h4,.pk-view-container ol>h5,.pk-view-container ol>h6,.pk-view-container ol>p{margin:0}.pk-view-container ol .ct-image{vertical-align:top}.pk-view-container ol hr{display:inline-block}.pk-view-container .ct-item-level-1{font-size:28px}.pk-view-container .ct-item-level-2{font-size:24px}.pk-view-container .ct-item-level-3{font-size:20px}.pk-view-container .ct-item-level-4{font-size:16px}.pk-view-container .ct-item-level-5{font-size:14px}.pk-view-container .ct-item-level-6{font-size:12px}.pk-view-container ol .ct-item-level-1{margin-left:12px}.pk-view-container ol .ct-item-level-2{margin-left:8px}.pk-view-container ol .ct-item-level-3{margin-left:5px}.pk-view-container ol .ct-item-level-4{margin-left:1px}.pk-view-container ol .ct-item-level-6{margin-left:-2px}.pk-view-container ol{list-style-type:decimal}.pk-view-container ol ol{list-style-type:lower-alpha}.pk-view-container ol ol ol{list-style-type:lower-roman}.pk-view-container ol ol ol ol{list-style-type:decimal}.pk-view-container ol ol ol ol ol{list-style-type:lower-alpha}.pk-view-container ol ol ol ol ol ol{list-style-type:lower-roman}.pk-view-container ol ol ol ol ol ol ol{list-style-type:decimal}.pk-view-container ol ol ol ol ol ol ol ol{list-style-type:lower-alpha}.pk-view-container ol ol ol ol ol ol ol ol ol{list-style-type:lower-roman}";
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var orderedListRender = function orderedListRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, orderedListRender);
    this.fragmentCls = ".".concat(classNamePrefix("ordered-list"));
    this.config = config;
};

export default orderedListRender;
//# sourceMappingURL=render.js.map
